import { render, staticRenderFns } from "./AppealDialog.vue?vue&type=template&id=1810b0ed&"
import script from "./AppealDialog.vue?vue&type=script&lang=js&"
export * from "./AppealDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports